import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MIQNAF_DETAIL_RCPA_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MiqnafRCPADetailReport = lazy(() =>
  import('@app/screens/MiqnafRCPADetailReport')
    .then(module => ({default: module.MiqnafRCPADetailReport})));

const MiqnafRCPADetailReportNavigation = [
  {
    path: ROUTE_MIQNAF_DETAIL_RCPA_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MiqnafRCPADetailReport />
      </Suspense>
    ),
  },
];

export default MiqnafRCPADetailReportNavigation;
